<template>
    <component v-if="itemDefinition" v-bind:is="itemDefinition.viewType" v-bind:itemDefinition="itemDefinition"></component>
</template>

<script>
    import PlotList from "./automated/PlotList";
    import PlotListFS from "./automated/PlotListFS.vue";
    import {mapGetters} from 'vuex'

    export default {
        name: 'UserAutomated',
        components: {PlotList,PlotListFS},
        computed: {
            ...mapGetters([
                'userPlots',
            ]),
            itemDefinition() {
                for (let item of this.userPlots){
                    if(item.id===this.$route.params.id){
                        let scopedItem = JSON.parse(JSON.stringify(item))
                        if (scopedItem.renderInFullScreen) {
                            scopedItem.viewType = 'PlotListFS'
                        }
                        return scopedItem
                    }
                }
                return null
            },
        }
    }
</script>
